import { DiseaseContentModel } from './diseaseContentModel';

export class DiseaseAdminModel {
  public diseaseId: number;
  public diseaseNameBG: string;
  public diseaseNameEN: string;
  public diseaseName: string;
  public diseaseDescription: string;
  public diseaseCode: string;
  public diseaseContent: Array<DiseaseContentModel>;
}